import { z } from 'zod';

export const WallpaperCategoryI18nRow = z.object({
  wallpaper_id: z.number().int().positive(),
  category_id: z.number().int().positive(),
  lang_code: z.string().min(2).max(5),
  slug: z.string().min(1),
  name: z.string().min(1),
  alt: z.string().nullable(),
  seo_title: z.string().nullable(),
  seo_h1: z.string().nullable(),
  seo_description: z.string().nullable(),
  seo_text: z.string().nullable(),
  is_ready: z.boolean(),
  is_stale: z.boolean(),
  ai_step_id: z.number().int().positive().nullable(),
  prompt_version: z.string().min(1),
  generated_at: z.string().datetime().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export type WallpaperCategoryI18n = z.infer<typeof WallpaperCategoryI18nRow>;

const now = '2026-01-15T10:00:00.000Z';

export const WALLPAPERS_CATEGORY_I18N: readonly WallpaperCategoryI18n[] = [
  // wp 1001, cat 1, en
  {
    wallpaper_id: 1001,
    category_id: 1,
    lang_code: 'en',
    slug: 'flowers-theme-en',
    name: 'Beautiful Flowers Theme',
    alt: 'Colorful flowers on white background',
    seo_title: 'Flowers Wallpaper | Wandero',
    seo_h1: 'Explore Beautiful Flower Designs',
    seo_description: 'Premium flower wallpapers for your home decoration',
    seo_text: 'Our flower collection features stunning botanical designs...',
    is_ready: true,
    is_stale: false,
    ai_step_id: 101,
    prompt_version: '1.0',
    generated_at: '2026-01-10T12:00:00.000Z',
    created_at: now,
    updated_at: now,
  },
  // wp 1001, cat 1, pl
  {
    wallpaper_id: 1001,
    category_id: 1,
    lang_code: 'pl',
    slug: 'flowers-theme-pl',
    name: 'Piękny Motyw Kwiatów',
    alt: 'Kolorowe kwiaty na białym tle',
    seo_title: 'Tapeta Kwiatki | Wandero',
    seo_h1: 'Odkryj Piękne Projekty Kwiatów',
    seo_description: 'Tapety premium z kwiatami do dekoracji domu',
    seo_text: 'Nasza kolekcja kwiatów zawiera wspaniałe projekty botaniczne...',
    is_ready: true,
    is_stale: false,
    ai_step_id: 102,
    prompt_version: '1.0',
    generated_at: '2026-01-10T12:15:00.000Z',
    created_at: now,
    updated_at: now,
  },
  // wp 1001, cat 6, en
  {
    wallpaper_id: 1001,
    category_id: 6,
    lang_code: 'en',
    slug: 'flowers-room-en',
    name: 'Flowers for Living Room',
    alt: 'Modern flower wallpaper for living spaces',
    seo_title: 'Living Room Flower Wallpaper',
    seo_h1: 'Flower Designs for Living Rooms',
    seo_description: 'Transform your living room with our flower wallpapers',
    seo_text: null,
    is_ready: false,
    is_stale: true,
    ai_step_id: null,
    prompt_version: '1.0',
    generated_at: null,
    created_at: now,
    updated_at: now,
  },
  // wp 1001, cat 6, pl
  {
    wallpaper_id: 1001,
    category_id: 6,
    lang_code: 'pl',
    slug: 'flowers-room-pl',
    name: 'Kwiaty do Salonu',
    alt: null,
    seo_title: null,
    seo_h1: null,
    seo_description: null,
    seo_text: null,
    is_ready: false,
    is_stale: false,
    ai_step_id: null,
    prompt_version: '1.0',
    generated_at: null,
    created_at: now,
    updated_at: now,
  },
  // wp 1002, cat 2, en
  {
    wallpaper_id: 1002,
    category_id: 2,
    lang_code: 'en',
    slug: 'ocean-theme-en',
    name: 'Ocean Wave Design',
    alt: 'Serene ocean waves wallpaper',
    seo_title: 'Ocean Wallpaper | Premium Designs',
    seo_h1: 'Ocean Inspired Wallpapers',
    seo_description: 'Bring the beauty of ocean waves to your walls',
    seo_text: 'Create a coastal atmosphere with our ocean collection...',
    is_ready: true,
    is_stale: false,
    ai_step_id: 201,
    prompt_version: '1.0',
    generated_at: '2026-01-11T14:00:00.000Z',
    created_at: now,
    updated_at: now,
  },
  // wp 1002, cat 2, pl
  {
    wallpaper_id: 1002,
    category_id: 2,
    lang_code: 'pl',
    slug: 'ocean-theme-pl',
    name: 'Projekt Fali Oceanu',
    alt: 'Spokojne fale oceanu',
    seo_title: 'Tapeta Oceanu | Projekty Premium',
    seo_h1: 'Tapety Inspirowane Oceanem',
    seo_description: 'Przynieś piękno fal oceanicznych na swoje ściany',
    seo_text: 'Stwórz przybrzeżną atmosferę dzięki naszej kolekcji oceanów...',
    is_ready: true,
    is_stale: false,
    ai_step_id: 202,
    prompt_version: '1.0',
    generated_at: '2026-01-11T14:15:00.000Z',
    created_at: now,
    updated_at: now,
  },
] as const;

WALLPAPERS_CATEGORY_I18N.forEach((row) => WallpaperCategoryI18nRow.parse(row));
